import api from '@/services/api';

class LprSiteService {
    view(request) {
        return api.get('/lpr/activation/'+request.id);
    }

    create(request) {
        return api.post('/lpr/activation', request);
    }

    updateModule(request) {
        return api.put('/lpr/activation/'+request.id, request.body);
    }

    activate(request) {
        return api.put('/lpr/activation/activate/'+request.id);
    }

    deactivate(request) {
        return api.put('/lpr/activation/deactivate/'+request.id);
    }

    company() {
        return api.get('/lpr/activation/pending');
    }
    
    vendor() {
        return api.get('/vendors');
    }
}

export default new LprSiteService();